module.exports = __webpack_public_path__ + "static/media/buttonopen.fc278925.png";